/*
 * Module for the Drop Deposit Process Job View
 */
rs.module("content/jobs/criteria/dropdepositprocesscontract",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the page
        function initialize(jsSelectors, backendUrl) {

            // Unpack js selectors
            var criteria = $.js(jsSelectors.criteria);

            var dropPlanSelect = criteria.js(jsSelectors.dropPlanSelect);

            var readonlySection = criteria.js(jsSelectors.readonlySection);
            var monthYear = criteria.js(jsSelectors.monthYear);
            var postingDateInput = criteria.js(jsSelectors.postingDateInput);

            var editableSection = criteria.js(jsSelectors.editableSection);
            var nextMonthSelect = criteria.js(jsSelectors.nextMonthSelect);
            var nextYearInput = criteria.js(jsSelectors.nextYearInput);

            // Use select helper for working with select list.
            var nextMonthSelectHelper = selectHelper.getHelper(nextMonthSelect);

            // Setup on change event.
            dropPlanSelect.change(planSelected);

            // On plan selection change, handle population of associated drop deposit batch fields.
            function planSelected() {

                // get selected plan
                var selectedPlanKey = dropPlanSelect.val();

                // load new drop deposit batch from backend.
                $.getJSON(backendUrl, { dropPlanKey: selectedPlanKey }).done(function (result) {

                    if (result.firstDepositBatchFlag) {

                        ShowEditFields(true);

                        // clear defaults.
                        nextMonthSelectHelper.setValue('');
                        nextYearInput.val('');
                    }
                    else {

                        ShowEditFields(false);

                        // prevent hidden fields from causing validation issues.
                        nextMonthSelectHelper.setValue(1);
                        nextMonthSelect.clearErrors();
                        nextYearInput.val(new Date().getFullYear()).clearErrors();

                        // populate fields
                        monthYear.text(result.processingMonthYear);
                        postingDateInput.text(result.postingDate);
                    }
                });
            }

            // Shows or Hides the readonly or Editable fields depending on input
            function ShowEditFields(isFirstDepositBatch) {
                if (isFirstDepositBatch) {
                    visibility.hide(readonlySection);
                    visibility.show(editableSection);
                }
                else {
                    visibility.hide(editableSection);
                    visibility.show(readonlySection);
                }
            }
        }

        var exports = {
            initialize: initialize
        };

        return exports;
    }
);